import styles from "./NavBar.module.css";

import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../utils/contextapi/AuthProvider";
import '../../resources/css/common.css';
import {Link} from "react-router-dom";
import dashboardIcon from '../../../src/resources/images/menu/menu_ico_1.svg';
import userIcon from '../../../src/resources/images/menu/menu_ico_2.svg';
import serviceIcon from '../../../src/resources/images/menu/menu_ico_3.svg';
import productIcon from '../../../src/resources/images/menu/menu_ico_4.svg';
import authIcon from '../../../src/resources/images/menu/menu_ico_5.svg';
import pageAuthIcon from '../../../src/resources/images/menu/menu_ico_6.svg';
import groupIcon from '../../../src/resources/images/menu/menu_ico_7.svg';
import serviceUserIcon from '../../../src/resources/images/menu/menu_ico_8.svg';
import auditIcon from '../../../src/resources/images/menu/menu_ico_9.svg';
// import hamber from "./HamburgerToggle.module.css";

export const NavType = {
    DASH: 'dashboard',
    // USER: 'usermgmt',
    // SERVICE: 'service',
    // AUTH: 'auth',
    // PAGE: 'page',
    // PAGE_AUTH: 'pageauth',
    GROUP: 'group',
    PRODUCT: 'product',
    SERVICE_USER: 'service_user',
    // AUDIT: 'audit'
}

// 1. 메뉴 배열로 관리
const menuList = [
    {
        key: "dash",
        path: "/dashboard",
        icon: dashboardIcon,
        label: "대시보드",
        roles: [] // 모든 권한 허용
    },
    {
        key: "group",
        path: "/group",
        icon: groupIcon,
        label: "계정관리",
        roles: ["SYS_ADMIN", "ADMIN_USER"]
    },
    {
        key: "product",
        path: "/product",
        icon: productIcon,
        label: "상품관리",
        roles: ["SYS_ADMIN"]
    },
    {
        key: "service_user",
        path: "/serviceuser",
        icon: serviceUserIcon,
        label: "관리자 관리",
        roles: ["SYS_ADMIN"]
    },
    // {
    //     key: "audit",
    //     path: "/audit",
    //     icon: auditIcon,
    //     label: "로그관리",
    //     roles: ["SYS_ADMIN"]
    // },
];


/**
 * Navigation Bar Container
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */
function NavBar({type}) {

    const {role} = useContext(AuthContext);

    //NavBar 탭 on/off css
    const [navToggle, setNavToggle] = useState({
        dash: '', group: '', product: '', service_user: '',
        audit: ''
    })

    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        setNavToggle({
            dash: type === NavType.DASH ? styles.on : '',                       // 대시보드
            group: type === NavType.GROUP ? styles.on : '',                     // 그룹관리
            product: type === NavType.PRODUCT ? styles.on : '',                       // 페이지관리
            service_user: type === NavType.SERVICE_USER ? styles.on : '',       // 서비스사용자관리
            audit: type === NavType.AUDIT ? styles.on : '',                     // 로그관리
        })
    }, [type]);

    const hasMenuAccess = (menuRoles) => {
        // menuRoles가 빈 배열이면 모든 사용자 허용
        if (menuRoles.length === 0) return true;

        return menuRoles.includes(sessionStorage.getItem('role'));
    };


    return (
        <>
            <section className={`${styles.leftCont} ${isExpanded ? styles.expanded : ""}`}>
                {/* <div className={styles.leftCont__toggleBtn} onClick={() => setIsExpanded(!isExpanded)} /> */}
                <div className={styles.leftCont__toggleBtn} onClick={() => setIsExpanded(!isExpanded)}>
                    <div className={`${styles.bar} ${isExpanded ? styles.bar1 : ''}`} />
                    <div className={`${styles.bar} ${isExpanded ? styles.bar2 : ''}`} />
                    <div className={`${styles.bar} ${isExpanded ? styles.bar3 : ''}`} />
                </div>
                <div className={styles.wrap}>
                <ul className={styles.leftCont__menu}>
                    {menuList.map(menu =>
                        hasMenuAccess(menu.roles) && (
                            <Link to={menu.path} className={styles.leftCont__menu__link__txt} key={menu.key}>
                                <li className={`${styles.leftCont__menu__li} ${styles[menu.key]} ${navToggle[menu.key]}`}>
                                    {/* <span className={styles.leftCont__menu__icon}> */}
                                        <img style={{width:'30px', height:'30px'}} src={menu.icon} alt={menu.label} />
                                    {/* </span> */}
                                    <p className={styles.leftCont__menu__link}><span>{menu.label}</span></p>
                                </li>
                            </Link>
                        )
                    )}
                </ul>
                </div>
            </section>
            <section className={styles.moMenuCont}>
                {/* <div className={styles.leftCont__toggleBtn} onClick={() => setIsExpanded(!isExpanded)} /> */}
                   
                    <ul className={styles.moMenuCont__menu}>
                    {menuList.map(menu =>
                        hasMenuAccess(menu.roles) && (
                        <Link to={menu.path} key={menu.key} className={styles.moMenuCont__menu__link}>
                            <li className={`${styles.moMenuCont__menu__li} ${styles[menu.key]} ${navToggle[menu.key]}`}>
                            <p><span>{menu.label}</span></p>
                            </li>
                        </Link>
                        )
                    )}
                    </ul>
            </section>
        </>
    )
}

export default NavBar;